import store from '../store/index.js';

function getTitle(vm) {
  const { title } = vm.$options
  if (title) {
    return typeof title === 'function'
      ? title.call(vm)
      : title
  }
}

export default {
  created() {
    const title = getTitle(this);
    if (title) {
      store.dispatch('SET_TITLE', title);
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      const title = getTitle(vm);
      store.dispatch('SET_TITLE', title);
    })
  }
}